import React from 'react';
import { useSelector } from 'react-redux';
import {
  useIsInterstitialFlow,
  useIsPreCartOfferFlow,
} from '../../../../../hooks/useOrderFlowContext';
import AddToCartButton from './AddToCartButton';
import DeclineInterstitialProductButton from './DeclineInterstitialProductButton';
import DeclinePreCartOfferProductButton from './DeclinePreCartOfferProductButton';
import ProductZoomImage from './ProductZoomImage';
import SelectedPosesAndBackgrounds from './SelectedPosesAndBackgrounds';
import StudentGroupImageComponent from './StudentGroupImageComponent';

// Left product-info column of RegularProductConfig (zoom image, product
// description, StudentGroupImageComponent, SelectedPosesAndBackgrounds, and
// the desktop add-to-cart / decline buttons).
interface ProductInfoPanelProps {
  addProductToCart: () => void;
  actionFooter?: React.ReactNode;
}

const ProductInfoPanel: React.FC<ProductInfoPanelProps> = ({
  addProductToCart,
  actionFooter,
}) => {
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );
  const backgroundsPosesSelectorVisible = useSelector(
    (state: any) => state.productConfig.backgroundsPosesSelectorVisible,
  );
  const isInterstitialProduct = useIsInterstitialFlow();
  const isPreCartOfferProduct = useIsPreCartOfferFlow();

  if (!product) return null;

  return (
    <div
      className={`bnl-product-config__product ${
        backgroundsPosesSelectorVisible ? 'element-hidden' : 'element-visible'
      }`}
    >
      <ProductZoomImage />
      <div className="bnl-product-config__product-desc">
        {product.description}
      </div>
      <StudentGroupImageComponent />
      <SelectedPosesAndBackgrounds />
      <div className="hidden-xs hidden-sm">
        <AddToCartButton addProductToCart={addProductToCart} />
        {actionFooter}
        {isInterstitialProduct && <DeclineInterstitialProductButton />}
        {isPreCartOfferProduct && <DeclinePreCartOfferProductButton />}
      </div>
    </div>
  );
};

export default ProductInfoPanel;
